module.exports = __webpack_public_path__ + "static/img/19009C_2_R_20201018_fit.4173f72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19009C_2_R_20201018_fit.png
// module id = xTax
// module chunks = 0